import { render, staticRenderFns } from "./TestsItem.vue?vue&type=template&id=28099fed&"
import script from "./TestsItem.vue?vue&type=script&lang=js&"
export * from "./TestsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports